/**
 * WHY A SESSION ENDED, carried across the trip back to the login page.
 *
 * Inactivity, an expired session, and a completed or uncertain password change require a fresh
 * login. The refresh failure path hard-redirects, so React state cannot carry its explanation.
 * The reason goes into
 * sessionStorage - it survives the redirect, it does not survive the tab, and Login consumes it
 * exactly once so a reload of the login page does not show the banner a second time.
 */
export const SESSION_ENDED_KEY = 'medeffects.sessionEnded';

export const SESSION_ENDED_MESSAGES = {
  inactivity: 'You were signed out after 30 minutes of inactivity. Please sign in again.',
  expired: 'Your session ended. Please sign in again.',
  password_changed: 'Your password was changed. Please sign in again with your new password.',
  password_change_uncertain: 'Your password change could not be confirmed. Please sign in again.',
};

/** @param {'inactivity' | 'expired' | 'password_changed' | 'password_change_uncertain'} reason */
export function markSessionEnded(reason) {
  try {
    sessionStorage.setItem(SESSION_ENDED_KEY, reason);
  } catch {
    // Storage disabled or full: the user still gets signed out, just without the explanation.
  }
}

/** Read and clear the reason. Returns the sentence to show, or '' when there is nothing to say. */
export function consumeSessionEnded() {
  try {
    const reason = sessionStorage.getItem(SESSION_ENDED_KEY);
    if (!reason) return '';
    sessionStorage.removeItem(SESSION_ENDED_KEY);
    return SESSION_ENDED_MESSAGES[reason] || SESSION_ENDED_MESSAGES.expired;
  } catch {
    return '';
  }
}
